import React, { useCallback, useEffect, useState } from 'react'
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
    MainContainer,
    ChatContainer,
    MessageList,
    Message,
    MessageInput,
    ConversationHeader,
} from "@chatscope/chat-ui-kit-react";

import './v2ChatPage.css'
import { useLocation, useNavigate } from 'react-router-dom';
import { useV2fetchChatSessionByIdQuery } from './chatSessionApiSlice';
import { ws_url } from '../../chat_logs/chatLogApiSlice';
import { withWsToken } from '../../../app/api/apiSlice';
import { useWebSocket } from 'react-use-websocket/dist/lib/use-websocket';
import { useV2createChatLogMutation } from '../chatlogs/chatLogApiSlice';

import { Button, Dropdown, Item, ItemContent } from 'semantic-ui-react';
import { resetBotResponse, setSuggestedResponses, updateBotResponse, updateModelCompletion } from '../streaming/botResponseSlice';
import { useDispatch, useSelector } from 'react-redux';
import { BRAND } from '../../../brand';


const ModelOptions = [
    { key: 'OpenAI', text: 'OpenAI', value: 'OPENAI' },
    { key: 'Custom model', text: 'Custom model', value: 'v2-745-gptq' },
]

const V2ChatSessionPerform = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const chatsessionId = queryParams.get("chatsession_id");
    const [msgInputValue, setMsgInputValue] = useState("");
    const [messages, setMessages] = useState([]);
    const [addChatLog, { data: addedChatLog, isLoading: isAdding }] = useV2createChatLogMutation();

    const botResponse = useSelector((state) => state.botResponse.botResponse);
    const modelCompletion = useSelector((state) => state.botResponse.modelCompletion);
    const suggestedResponses = useSelector((state) => state.botResponse.suggestedResponses);
    const [model, setModel] = useState(ModelOptions[0].value);
    const [showSuggested, setShowSuggested] = useState(false);
    const [seen, setSeen] = useState(false);
    const dispatch = useDispatch();

    const {
        data: chatSession,
        refetch,
    } = useV2fetchChatSessionByIdQuery(chatsessionId);

    // Memoized url getter: react-use-websocket keys its connect effect on the
    // url arg, so an inline arrow reconnects every render (infinite storm).
    // withWsToken reads the token at call time, so reconnects stay fresh.
    const getSocketUrl = useCallback(
        () => withWsToken(ws_url.replace("{session_id}", chatsessionId)),
        [chatsessionId]
    );
    const { lastMessage } = useWebSocket(getSocketUrl, {
        shouldReconnect: (closeEvent) => true,
    });

    useEffect(() => {
        if (chatSession) {
            const chatlogs = chatSession.chatlog_set.map(item => ({
                message: item.utterance,
                direction: item.speaker === 'B' ? 'incoming' : 'outgoing'
            }));

            setMessages(chatlogs);
            setModel(chatSession.llm_model);
        }
    }, [chatSession, navigate])


    useEffect(() => {
        if (lastMessage) {
            dispatch(updateModelCompletion(lastMessage.data))
            if (model === ModelOptions[0].value && !seen) {
                if ((/"response" *: *"/).test(modelCompletion) && !(/"response" *: *".*",/).test(modelCompletion)) {
                    // The last token can consist of the last character + the last double quote.
                    // So remove the double quote in the message even if this code exists in the if conditional statement.
                    if (lastMessage.data.trim("").includes('",')) {
                        setSeen(true)
                    }
                    dispatch(updateBotResponse(lastMessage.data.replace('",', '')))
                }
            } else if (model === ModelOptions[1].value) {
                dispatch(updateBotResponse(lastMessage.data))
            }
        }
    }, [lastMessage])


    const handleSend = (message) => {
        setSeen(false);
        setMessages(messages.concat([
            {
                message: botResponse,
                direction: 'incoming'
            }, {
                message,
                direction: 'outgoing'
            }]));

        setMsgInputValue("");
        dispatch(resetBotResponse());

        addChatLog({
            session: chatsessionId,
            utterance: message,
            stream: true,
        });
    };


    useEffect(() => {
        if (addedChatLog) {
            // If the model is not OPENAI and ChatSession Language is not ENGLISH streaming does NOT work, so we display received response entirely 
            if (botResponse === "") {
                dispatch(updateBotResponse(addedChatLog.bot_response.utterance))
            }
            dispatch(setSuggestedResponses(addedChatLog.suggested_responses))
        }
    }, [addedChatLog])


    const toggleSuggested = () => {
        setShowSuggested(!showSuggested);
    };


    return (
        <div style={{ position: "absolute", height: "100vh", bottom: 0, right: 0, width: '100vw' }}>
            <MainContainer>
                <ChatContainer>
                    <ConversationHeader>
                        <ConversationHeader.Content userName={`Apple • ${BRAND}`}></ConversationHeader.Content>
                    </ConversationHeader>
                    <MessageList>
                        {messages.map((m, i) => m.message !== "" && <Message key={i} model={m} />)}
                        {botResponse !== "" && <Message model={{ message: botResponse, direction: 'incoming' }} style={{ borderRadius: 10 }} />}
                        {showSuggested &&
                            suggestedResponses.map((sr, i) =>
                                <Message className='suggested-messages' key={i} model={{ message: sr, direction: 'outgoing' }} onClick={() => { handleSend(sr); setShowSuggested(false) }} style={{ borderRadius: 10, cursor: 'pointer' }} />
                            )
                        }
                    </MessageList>
                    <MessageInput sendDisabled={isAdding} sendOnReturnDisabled={isAdding} attachButton={false} placeholder="Type message here" onSend={handleSend} onChange={setMsgInputValue} value={msgInputValue} autoFocus />
                </ChatContainer>
            </MainContainer>
            {suggestedResponses.length !== 0 && !isAdding && <Button className='v2-chat-suggested-responses-button' onClick={toggleSuggested}>
                {showSuggested ? 'Hide' : 'Show'} suggested responses
            </Button>}
        </div >
    )
}

export default V2ChatSessionPerform